import React from "react";

const ErrorMessage = ({ message }: { message: string }) => {
  return (
    <div className="block-alert block-alert--warning rte">
      <p>{message}</p>
    </div>
  );
};

export default ErrorMessage;
